module.exports = __webpack_public_path__ + "36938bbe277961386e7e309dcb30cbd8.svg";